module.exports = __webpack_public_path__ + "static/wrangler_logo-fa5fd976d72138019b069b768e192a6a.svg";